import React, { useEffect, useState } from 'react';
import savingIcon from '../../Assets/savingIcon.png';
import savedIcon from '../../Assets/savedIcon.png';
import { useDispatch, useSelector } from 'react-redux';
import './savingSaved.css';
import { useParams } from 'react-router-dom';
import { workwiseServices } from '../../Services/workWiseServices';
import { Tooltip } from 'antd';
import { setIsDocumentChanged } from '../../Reducers/documentInfoSlice';

const SavingSaved = () => {
    const id = useParams();
    const dispatch = useDispatch();
    const savingData = useSelector((state) => state.documentData.savingData);
    const isDocumentChanged = useSelector((state) => state.documentData.isDocumentChanged);
    const spaceData = useSelector((state) => state.mileSpace.spaceData);
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 845);

    useEffect(() => {
        const saveDocument = async () => {
            if (isDocumentChanged) {
                await workwiseServices.saveDocumentlastUpdate(id, dispatch, spaceData);
                dispatch(setIsDocumentChanged(false));
            }
        };
        saveDocument();
    }, [spaceData, isDocumentChanged]);

    useEffect(() => {
        const handleResize = () => setIsSmallScreen(window.innerWidth < 845);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className={'SavedData-Conatiner'}>
            {savingData && (
                <>
                    {savingData.isSaving === 'Saving...' ? (
                        <>
                            <img src={savingIcon} alt="Saving document" style={{ width: '22px' }} />
                            <span>{savingData.isSaving}</span>
                        </>
                    ) : savingData.isSaving === 'Saved' ? (
                        isSmallScreen ? (
                            <Tooltip title={savingData.lastSavedDateTime ? `${savingData.lastSavedDateTime}, ${savingData.fileSize}` : savingData.fileSize}>
                                <img src={savedIcon} alt="Saved document" style={{ width: '24px', cursor: 'pointer' }} />
                            </Tooltip>
                        ) : (
                            <>
                                <img src={savedIcon} alt="Saved document" style={{ width: '24px', cursor: 'default' }} />
                                <span>{savingData.lastSavedDateTime}{`, ${savingData.fileSize}`}</span>
                            </>
                        )
                    ) : (
                        savingData.fileSize && <span>{savingData.fileSize}</span>
                    )}
                </>
            )}
        </div>
    );
};

export default SavingSaved;
